// Font variables for the entire application
// Based on modern dashboard design with consistent typography

export const fonts = {
  // Title font size - single size used for all titles
  titleSize: '32px',
  
  // Description font size - used throughout the app for descriptions
  descriptionSize: '14px',
  
  // Additional font sizes
  fontSizeXxs: '8px',
  fontSizeXs: '10px',
  fontSizeSm: '11px',
  fontSizeMd: '14px',
  fontSizeLg: '16px',
  fontSizeXl: '18px',
  fontSize2xl: '20px',
  fontSize3xl: '24px',
  fontSize4xl: '32px',
  fontSize5xl: '36px',
  
  // Font weights
  weightLight: 300,
  weightNormal: 400,
  weightMedium: 500,
  weightSemiBold: 600,
  weightBold: 700,
  
  // Font families
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontFamilyMono: '"Roboto Mono", "Courier New", monospace',
  
  // Line heights
  lineHeightTight: 1.2,
  lineHeightNormal: 1.5,
  lineHeightRelaxed: 1.75,
  
  // Letter spacing
  letterSpacingTight: '-0.02em',
  letterSpacingNormal: '0',
  letterSpacingWide: '0.02em',
};

// Border radius values - Soft, rounded corners
export const borderRadius = {
  none: '0',
  sm: '6px',
  md: '10px',
  lg: '16px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '32px',
  full: '9999px',
  
  // Specific use cases - Extra rounded for soft aesthetic
  button: '12px',
  card: '24px',
  input: '12px',
  modal: '24px',
};

// Spacing values (for consistent padding/margins) - Ample white space
export const spacing = {
  xs: '6px',
  sm: '12px',
  md: '20px',
  lg: '32px',
  xl: '40px',
  '2xl': '56px',
  '3xl': '80px',
};

// Button styles
export const buttonStyles = {
  primary: {
    background: 'linear-gradient(135deg, #233491 0%, #2f4ac4 100%)',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '14px',
    padding: '12px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    '&:hover': {
      background: 'linear-gradient(135deg, #2f4ac4 0%, #233491 100%)',
    },
    '&:disabled': {
      backgroundColor: '#E5E7EB',
      color: '#9CA3AF',
      cursor: 'not-allowed',
    },
  },
  secondary: {
    backgroundColor: '#F5F7FA',
    color: '#1A1A1A',
    fontWeight: 500,
    fontSize: '14px',
    padding: '12px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#E8EBF0',
    },
  },
  outline: {
    backgroundColor: 'transparent',
    color: '#1A1A1A',
    border: '1px solid #E0E0E0',
    fontWeight: 500,
    fontSize: '14px',
    padding: '12px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#F5F7FA',
      borderColor: '#D0D0D0',
    },
  },
  text: {
    backgroundColor: 'transparent',
    color: '#666666',
    fontWeight: 500,
    fontSize: '14px',
    padding: '8px 16px',
    borderRadius: '8px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#F5F7FA',
      color: '#1A1A1A',
    },
  },
};

// Shadow values - Soft, subtle shadows
export const shadows = {
  none: 'none',
  sm: '0 1px 3px rgba(0, 0, 0, 0.03)',
  md: '0 4px 12px rgba(0, 0, 0, 0.04)',
  lg: '0 10px 24px rgba(0, 0, 0, 0.06)',
  xl: '0 20px 40px rgba(0, 0, 0, 0.08)',
  card: '0 4px 20px rgba(0, 0, 0, 0.04)',
  cardHover: '0 8px 30px rgba(0, 0, 0, 0.08)',
  button: '0 2px 8px rgba(0, 0, 0, 0.2)',
  buttonHover: '0 4px 12px rgba(0, 0, 0, 0.3)',
  input: '0 0 0 3px rgba(0, 0, 0, 0.1)',
  glass: '0 4px 16px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)',
};
